<template>
    <el-container class="page-container wrap">
        <el-header class="page-header" height="34px">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">锐眼视界</el-breadcrumb-item>
                <el-breadcrumb-item>{{ currentPageTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
        </el-header>
        <el-container>
            <el-aside class="page-aside" width="240px">
                <div class="aside-container">
                    <div class="aside-item aside-title">{{ asideData.title }}</div>
                    <div v-for="item in asideData.menu" :key="item.name" class="aside-item aside-link" :class="getAsideCurrent(item)" @click="handleItemClick(item)">{{ item.label }}</div>
                </div>
            </el-aside>
            <el-main class="page-main">
                <slot></slot>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import aboutRouter from '/src/router/modules/about';
import interfaceRouter from '/src/router/modules/interface';
import userRouter from '/src/router/modules/user';

// 获取菜单
function getMenuData(data) {
    return data.filter(item => !item.menuHidden).map(({ name, meta }) => {
        return {
            name,
            label: meta.title
        };
    });
}

const pageCfg = {
    about: {
        title: aboutRouter.meta.title,
        menu: getMenuData(aboutRouter.children),
    },
    user: {
        title: userRouter.meta.title,
        menu: getMenuData(userRouter.children),
    },
    interface: {
        title: interfaceRouter.meta.title,
        menu: getMenuData(interfaceRouter.children),
    },
};

export default {
    name: "CpageLayout",    
    props: {
        pageType: {
            type: String,
            default: 'about',
        },
    },
    data() {
        return {
            currentPageTitle: '',
        };
    },
    computed: {
        userInfo() {
            return this.$store.getters.userInfo || {};
        },
        asideData() {
            const { pageType, userInfo } = this;
            const tmpMenu = pageCfg[pageType] || {
                title: '',
                menu: [],
            };

            if (pageType === 'user' && !userInfo.isCompany) {
                // API管理页面 - 先写死
                tmpMenu.menu = tmpMenu.menu.filter(item => item.name !== 'userApi');                
            }

            return tmpMenu;
        },
        routeMenuName() {
            const { $route } = this;

            return $route.meta.menuName || $route.name || '';
        },
    },
    created() {},
    mounted() {
        // console.log(this.$route);
    },
    methods: {
        getAsideCurrent(item) {
            const { routeMenuName } = this;

            // 设置左侧菜单高亮状态
            if (item.name === routeMenuName) {
                this.currentPageTitle = item.label;

                return 'current';
            }

            return '';
        },

        handleItemClick(item) {
            this.$router.push({
                name: item.name,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./pageLayout";
</style>
